import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const Termo = () => {
  const { id_cliente, token } = useParams();
  const navigate = useNavigate();

  const handleAccept = async () => {
    try {
      const response = await fetch('https://novo.faestal.com.br/termo/validartoken.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, id_cliente }),
      });
      const result = await response.json();
      alert(result.message);
      
      // Redirecionar para a raiz do portal após aceitar
      if (result.status === 'success' || result.status === 'ok') {
        setTimeout(() => {
          navigate('/');
        }, 1500);
      }
    } catch (error) {
      alert('Erro ao validar o token.');
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: '#27355c' }}>
        <div className="container d-flex justify-content-center">
          <img src="/coworking-itaguai-1.png" alt="Your Logo" width="180" />
        </div>
      </nav>
      
      <div className="container mt-5">
        <h2 className="text-center">TERMOS E CONDIÇÕES GERAIS DE PRESTAÇÃO DE SERVIÇOS DE ESCRITÓRIO/COWORKING</h2>
        <br/>
        <p>
          FAESTAL INDUSTRIAL LTDA, pessoa jurídica de direito privado, inscrita no
          CNPJ sob o nº 29,085,032/0003-80, com sede nesta cidade de Itaguaí, RJ,
          na Rua Curvelo Cavalcanti, nº 275, Centro, CEP 23.810-201, nome Fantasia
          FAEWORKS, que tem por atividade principal, Serviços combinados de
          escritório, apoio administrativo, Coworking e escritório virtual, doravante
          denominada FAEWORKS.
        </p>
        <h5>OBJETIVOS DA EMPRESA:</h5>
        <p>
          A FAEWORKS tem como objetivo o aluguel de espaços físicos como salas,
          salões e bancadas individuais por hora, com prévio agendamento e de
          acordo com a política de preço da FAEWORKS.
        </p>
        <p>
          O serviço inclui o direito ao uso de espaços demarcados, localizados nas
          dependências da Faeworks, com cadeiras, mesas, acesso livre a internet
          (wi-fi), utilização de banheiros conjuntos, contemplado no valor pago, todo
          o custo operacional. O local aqui firmado, poderá sofrer alteração sem
          prévio aviso da Faeworks, desde que ofertado espaço com o mesmo padrão
          ou melhor, em dependências de sua propriedade.
        </p>
        <h5>CONTRATO GERAL:</h5>
        <p>
          1. Prejuízos eventualmente gerados pela má utilização do espaço
          locado, deverão ser ressarcidos/indenizados pela contratante do
          serviço.
        </p>
        <p>
          2. Não está incluído no contrato, a disponibilização de computadores,
          laptops ou qualquer outro periférico, sendo de responsabilidade da
          contratante dos serviços, tais equipamentos.
        </p>
        <p>
          3. Não poderá a contratante trazer para as dependências da FAEWORKS
          impressora, fax, Scanner e qualquer tipo de periférico, salvo por
          expressa autorização da FAEWORKS que constará no campo
          observação do contrato firmado.
        </p>
        <p>
          4. O contrato não gerará a FAEWORKS qualquer espécie de vínculo com
          a contratante diverso do previsto no objeto do contrato, que é de
          locação de imóvel comercial por período de horas.
        </p>
        <p>
          5. Fica pactuado entre as partes a total inexistência de vínculo
          trabalhista, obrigações previdenciárias e os encargos sociais, bem
          como de qualquer vínculo entre as atividades de Contratante e
          FAEWORKS, não havendo entre ambas qualquer tipo de relação de
          subordinação ou comercial que não seja as previstas em contrato,
          sendo obrigação da Contratante esclarecer tal fato aos seus clientes,
          funcionários, prepostos ou a quem, de qualquer forma tenha relação
          com a contratante no local disponibilizado pela FAEWORKS.
        </p>
        <p>
          6. São excluídas da FAEWORKS, todas as responsabilidades decorrentes
          de relações contratuais existentes entre a contratante e terceiros.
          Qualquer relação contratual havida entre contratante e terceiros, no
          interior do estabelecimento da FAEWORKS, não gera a esta qualquer
          responsabilidade solidária ou sequer subsidiária, seja em face da
          contratante ou do terceiro.
        </p>
        <p>
          7. Não será de responsabilidade da FAEWORKS, acidentes ocorridos
          com o contratante, seus prepostos, clientes, empregados, no interior
          de seu estabelecimento, seja por mau uso dos equipamentos que
          disponibiliza, seja por problemas de saúde do contratante ou por este
          gerados.
        </p>
        <p>
          8. Não estará incluso no contrato o fornecimento de alimentos ou
          lanches, tipo Coffe Break e outros. No caso da Contratante vir a
          contratar empresa para esse fim, a FAEWORKS não se
          responsabilizará por quaisquer eventuais problemas relacionados a
          distribuição e consumo dos alimentos, ficando exclusivamente por
          conta da Contratante e da empresa contratada para essa finalidade,
          tal responsabilidade.
        </p>
        <p>
          9. Se houver, durante o curso do período contratual, a disponibilização
          de serviços que não estejam incluídos no contrato formalizado, como
          por exemplo a utilização de outro espaço do imóvel (sujeito a
          disponibilidade de horários), impressões, telefonia ou qualquer outro
          que possa ser disponibilizado pela FAEWORKS, que não esteja
          previsto no serviço descrito no contrato, o contratante deverá pagar
          à parte o valor do serviço extra utilizado, segundo a política de preços
          praticada pela FAEWORKS.
        </p>
        <p>
          10. A FAEWORKS é obrigada a disponibilizar o espaço ao contratante,
          pelo número de horas e dias, previsto no contrato sendo que
          qualquer ato de mera liberalidade da FAEWORKS não a vincula.
        </p>
        <p>
          11. A FAEWORKS disponibilizará acesso à Internet, sendo porém de
          conhecimento e consentimento da contratante que tal fornecimento
          depende dos provedores de tal serviço, não sendo indenizáveis ou
          compensáveis pela FAEWORKS eventuais falhas de fornecimento
          destes provedores.
        </p>
        <p>
          12. É vedada as partes a subcontratação ou cessão total ou parcial dos
          direitos e obrigações decorrentes do contrato, inclusive seus
          créditos, sem a prévia e expressa autorização da outra parte.
        </p>
        <p>
          13. No contrato, a FAEWORKS informará o horário de funcionamento do
          imóvel, que poderá sofrer alterações sem que isso configure falha na
          prestação de serviço, desde que não gere prejuízo ao plano de horas
          adquirido pela Contratante.
        </p>
        <p>
          14. Em caso fortuito, força maior ou feriados locais ou regionais, o
          horário de funcionamento pode ser alterado sem prévio aviso à
          contratante, não importando em violação da disponibilização do
          espaço nos termos do contrato, nem gerando tal fato, qualquer
          responsabilidade civil para a FAEWORKS.
        </p>
        <p>
          15. Pelos serviços contratados, o Contratante pagará a FAEWORKS de
          forma vincenda os valores referentes ao plano de serviços escolhido,
          de acordo com a tabela vigente à época da contratação, observando-
          se a forma, prazo, termos e condições de pagamento previstos no
          contrato.
        </p>
        <p>
        16. Quaisquer prejuízos materiais, decorrentes de danos ao
estabelecimento, bem como eventuais danos a honra objetiva da
FAEWORKS, serão ressarcidos pela contratante, na forma da lei, ou
em eventual Ação de Responsabilidade Civil por Danos Materiais ou
Morais, decorrentes de atos da contratante, sem prejuízo da
Responsabilidade Criminal, se for o caso.
        </p>
        <p>
        17. O Contratante será o único responsável pela prestação de seus
        serviços ou produtos, que são de natureza pessoal e intransferível.
        </p>
        <p>
        18. A Contratante se responsabiliza pelo uso e zelo dos bens móveis e
do imóvel da FAEWORKS, devendo indenizá-la pela má utilização do
espaço por si, seus clientes, funcionários e qualquer tipo de preposto.
        </p>
        <p>
        19. A FAEWORKS em momento nenhum será responsável pela guarda
de pertences da contratante que sejam deixadas em suas
dependências, nem mesmo nos armários (Lockers) disponibilizados
gratuitamente.
        </p>
        <p>
        20.Fica expressamente proibida a utilização do espaço para fins ilícitos,
tais como, exemplificadamente, crime cibernético, pedofilia,
prostituição e/ou outros ilícitos que violem a Constituição, leis e
outras normas vigentes no Brasil.
        </p>
        <p>
        21. É vedado a Contratante emprestar, dividir, dar em comodato,
sublocar ou de qualquer forma ceder o espaço a ela destinado, seja
por qual período for, respondendo caso isso ocorra, pelos eventuais
danos causados por terceiros estranhos ao contrato e devendo pagar
a FAEWORKS o valor do tempo utilizado, mais multa de 50% deste
valor, sem prejuízo da rescisão do contrato por culpa exclusiva do
contratante.
        </p>
        <p>
        22. O nível de ruído deve ser o mínimo possível de modo a não perturbar
os demais clientes, sendo vedada a entrada de animais, bem como
fumar dentro das dependências da FAEWORKS.
        </p>
        <p>
        23. Fica autorizada a utilização exclusivamente pela Contratante de
imagens do espaço locado, sendo vedada a utilização do espaço para
gravações ou escutas ambientais com ou sem autorização de todos
interlocutores.
        </p>
        <p>
        24. Fica autorizado à FAEWORKS a veiculação do direito de imagem da
Contratante, gratuitamente, podendo exibi-la nos seus meios de
comunicação como sites, redes sociais, eventos, materiais de
propaganda e afins o que não caracterizará vínculo de qualquer
natureza, nem gerando direito a indenização ou qualquer outra
forma de remuneração a contratante.
        </p>
        <p>
        25. A FAEWORKS, por mera liberalidade, poderá oferecer local para que
o Contratante disponibilize materiais promocionais e de divulgação
de seus serviços e produtos, como por exemplo, cartão de visita,
folder, panfleto e outros materiais de divulgação. A FAEWORKS no
entanto, não se responsabilizará pela gestão e uso destes materiais e
nem será responsável perante os clientes do Contratante sobre
serviços e/ou informações do Contratante.
        </p>
        <p>
        26.Fica vedada ao Contratante a utilização do endereço da FAEWORKS
        como seu endereço Comercial ou Fiscal.
        </p>
        <p>
        27. O Contratante não está autorizado a enviar correspondências
        pessoais ou de sua empresa para o endereço da FAEWORKS.
        </p>
        <p>
        28. O Contratante não poderá somar, salvar ou acumular frações de
horas não utilizadas em seu pacote, sendo certa que a utilização de
qualquer período de tempo dentro da hora vigente, contará com 01
hora inteira.
        </p>
        <p>
        29. O não pagamento pelos serviços contratados, acarretará a
suspensão do serviço até seu efetivo pagamento, sem prejuízo da
cobrança de saldo remanescente acrescido de multa de 10% e juros
de mora de 1% ao mês por rata die.
        </p>
        <p>
        30. Em caso de mora ou inadimplência do Contratante, será facultado à
FAEWORKS, visando assegurar seu crédito, fazer inscrever o nome
dos contratantes em bancos de dados cadastrais (SPC/SERASA/DPC
ou órgão equivalente), protestar o débito, ceder tal crédito, valer-se
de firma especializada ou contratar advogados, sendo que, neste
caso, o Contratante responderá também pelos honorários desses
profissionais e demais custos incorridos.
        </p>
        <p>
        31. Caso o Contratante utilize o objeto deste contrato fora do prazo
contratual, por qualquer motivo, torna-se devedor do valor relativo
às horas avulsas do espaço utilizado.
        </p>
        <p>
        32. Em caso de agendamento de dia e hora de espaço, deverá o
Contratante efetuar o pagamento integral do valor para que possa
ser reservado tal espaço. A contratante poderá desistir do contrato
no prazo de 07 (sete) dias a contar da data do agendamento do
espaço.(Art. 49 – Código de defesa do Consumidor).
        </p>
        <p>
        33. CONFIDENCIALIDADE: O contrato e toda a informação,
conhecimento e/ou dados, sejam eles técnicos ou não, tangíveis ou
em formato eletrônico, que no curso da sua execução tenham sido
ou venham a ser revelados pelo ou ao Contratado e Contratante,
serão considerados informações confidenciais. A obrigação de sigilo
deverá ser mantida durante a vigência do contrato e por 02 (dois)
anos após o seu término, independente do motivo do término.
        </p>
        <p>
        34. TRATAMENTO DE DADOS PESSOAIS: Para fins de preservação da
privacidade de titulares de dados, a FAEWORKS declara que adota as
melhores práticas de proteção de dados pessoais, respeitando toda
e qualquer legislação relativa à proteção de dados, em especial a Lei
13.709 (Lei Geral de Proteção de Dados – LGPD).
        </p>
        <p>
        34.1. O Contratante reconhece e aceita que a FAEWORKS poderá
coletar e tratar dados pessoais relativos a si e/ou ao seu
pessoal no âmbito do Contrato, utilizando-os exclusivamente
para os fins indispensáveis à consecução do objeto deste
Contrato ou de obrigações legais, comprometendo-se a exclui-
los (i) tão logo seja atingida a finalidade de seu uso ou (ii)
quando encerrado o prazo determinado da obrigação legal, o
que ocorrer por último.
        </p>
        <p>
        35. REGÊNCIA E FORO: O Contrato firmado entre FAEWORKS e o
Contratado será regido pelos presente Termos e Condições Gerais e
pela Legislação pertinente.<br/><br/>
O Contrato será regido pelas leis da República Federativa do Brasil.<br/><br/>
Fica eleito o Foro da Comarca de Itaguaí, no Estado do Rio de Janeiro,
como competente para qualquer ação judicial oriunda do Contrato
firmado entre Contratante e FAEWORKS, excluído qualquer outro,
por mais privilegiado que seja.
        </p>
        
        <div className="text-center mt-4">
          <button type="button" className="btn btn-primary" onClick={handleAccept}>Aceitar Contrato</button>
        </div>
        

      </div>
    </>
  );
};

export default Termo;